export const categories = [
  { slug: 'shipin', name: '视频资源', icon: 'ri-video-line', description: '挠脚心vk精彩视频合集' },
  { slug: 'shequ', name: '社区讨论', icon: 'ri-chat-3-line', description: 'VK社区热门讨论帖' },
  { slug: 'wenzhang', name: '文章资讯', icon: 'ri-article-line', description: '深度文章与资讯解读' },
  { slug: 'huati', name: '话题标签', icon: 'ri-hashtag', description: '热门话题与标签聚合' },
  { slug: 'ziyuan', name: '资源合集', icon: 'ri-folder-zip-line', description: '挠脚心vk资源汇总' },
];

export const topics = [
  { slug: 'naojiaoxin-vk-shipin', name: '挠脚心vk视频', count: 128 },
  { slug: 'vk-naoyang-shipin', name: 'vk挠痒视频', count: 96 },
  { slug: 'naojiaoxin-shequ', name: '挠脚心社区', count: 84 },
  { slug: 'naojiaoxin-huati', name: '挠脚心话题', count: 72 },
  { slug: 'naojiaoxin-ziyuan', name: '挠脚心资源', count: 65 },
  { slug: 'vk-quanzi', name: 'VK圈子', count: 58 },
  { slug: 'jiaoxin-tiaozhan', name: '脚心挑战', count: 47 },
  { slug: 'naojiaoxin-jiaoliu', name: '挠脚心交流', count: 43 },
  { slug: 'vk-redian', name: 'VK热点', count: 39 },
  { slug: 'quwei-shipin', name: '趣味视频', count: 35 },
  { slug: 'hudong-neirong', name: '互动内容', count: 31 },
  { slug: 'resou-paihang', name: '热搜排行', count: 28 },
];

export const articles = [
  {
    slug: 'naojiaoxin-vk-2024-redian-pan',
    title: '挠脚心vk 2024年度热点盘点：最受欢迎的内容与趋势',
    excerpt: '回顾2024年挠脚心vk平台上最受关注的热门话题、视频内容和社区讨论，深度分析用户偏好与内容趋势变化。',
    content: `<p>挠脚心vk作为当下热门的内容聚合平台，在2024年迎来了用户量和内容量的爆发式增长。本文将全面盘点2024年度挠脚心vk平台上的热门内容与趋势变化。</p>
<h2>一、热门视频内容分析</h2>
<p>2024年，挠脚心vk视频内容呈现出多元化的趋势。从早期的单一趣味挑战视频，发展到如今涵盖搞笑互动、创意短片、生活记录等多种类型。其中，<strong>互动挑战类视频</strong>最受用户欢迎，播放量占据平台总量的45%以上。</p>
<p>值得一提的是，VK平台上的挠痒视频因其轻松有趣的特性，吸引了大量年轻用户的关注和参与。许多创作者通过独特的创意和幽默的表达方式，获得了数十万甚至上百万的播放量。</p>
<h2>二、社区讨论热度</h2>
<p>挠脚心vk社区讨论区在2024年成为用户交流的核心阵地。每天有数以万计的帖子被发布，涵盖话题讨论、资源分享、创作经验等多个方面。</p>
<p>社区中热门话题包括：<strong>挠脚心技巧分享</strong>、<strong>VK平台使用教程</strong>、<strong>视频创作心得</strong>等。用户之间的互动频率高，社区氛围活跃。</p>
<h2>三、年度趋势总结</h2>
<p>综合来看，2024年挠脚心vk平台呈现出以下趋势：内容创作更加专业化、社区互动更加深入、话题讨论更加多元化。预计2025年，平台将持续吸引更多用户和创作者加入。</p>`,
    category: 'wenzhang',
    topics: ['naojiaoxin-vk-shipin', 'naojiaoxin-huati', 'vk-redian'],
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20content%20creation%20workspace%20with%20warm%20lighting%2C%20laptop%20displaying%20social%20media%20analytics%2C%20creative%20studio%20atmosphere%2C%20soft%20coral%20and%20cream%20tones%2C%20editorial%20photography%20style%2C%20clean%20aesthetic&width=800&height=450&seq=article-cover-01&orientation=landscape',
    date: '2025-08-08',
    readTime: '8分钟',
    viewCount: 15820,
  },
  {
    slug: 'vk-naojiaoxin-shequ-wanfa',
    title: 'VK挠脚心社区玩法全攻略：从入门到精通',
    excerpt: '全面介绍VK挠脚心社区的各类玩法、互动规则和隐藏技巧，帮助新用户快速融入社区，老用户发现更多乐趣。',
    content: `<p>VK挠脚心社区已经发展成为一个拥有丰富玩法和互动机制的活跃社群。无论你是刚接触挠脚心vk的新用户，还是已经活跃已久的老用户，本攻略都将为你提供有价值的玩法指南。</p>
<h2>一、社区基础玩法</h2>
<p>首先，新用户需要了解VK挠脚心社区的基本操作：<strong>注册账号</strong>、<strong>完善个人资料</strong>、<strong>关注感兴趣的创作者</strong>。完成这些基础设置后，就可以开始探索社区的丰富功能了。</p>
<p>社区的核心功能包括：发布帖子、评论互动、点赞收藏、私信交流等。<strong>帖子发布</strong>是社区最基本的互动方式，你可以分享自己的见解、提出问题或发布有趣的内容。</p>
<h2>二、进阶玩法技巧</h2>
<p>对于已经熟悉基础功能的老用户，以下进阶技巧将帮助你获得更好的社区体验：</p>
<p><strong>话题标签使用</strong>：合理使用挠脚心vk相关话题标签，可以让你的帖子被更多人看到。建议每个帖子添加3-5个相关标签。</p>
<p><strong>定时发布策略</strong>：根据社区活跃数据，晚间8-11点是用户最活跃的时间段，选择此时发布内容可以获得更多曝光。</p>
<h2>三、社区规则与礼仪</h2>
<p>在享受社区乐趣的同时，请遵守社区规则：尊重他人、不发布违规内容、积极参与建设性讨论。良好的社区氛围需要每一位用户的共同维护。</p>`,
    category: 'shequ',
    topics: ['naojiaoxin-shequ', 'naojiaoxin-jiaoliu', 'vk-quanzi'],
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20community%20gathering%20concept%2C%20people%20connecting%20digitally%2C%20soft%20ambient%20warm%20lighting%2C%20modern%20social%20media%20interface%20mockup%2C%20coral%20and%20cream%20color%20palette%2C%20friendly%20atmosphere%2C%20editorial%20style&width=800&height=450&seq=article-cover-02&orientation=landscape',
    date: '2025-08-06',
    readTime: '10分钟',
    viewCount: 23450,
  },
  {
    slug: 'naojiaoxin-vk-shipin-chuangzuo',
    title: '挠脚心vk视频创作指南：如何制作爆款内容',
    excerpt: '从选题策划到拍摄剪辑，全方位解析挠脚心vk视频的创作流程，分享提升视频质量和流量的实用技巧。',
    content: `<p>在挠脚心vk平台上，优质的视频内容永远是吸引用户的核心。本指南将从内容策划、拍摄技巧、后期制作三个维度，全面解析如何创作出受欢迎的挠脚心vk视频。</p>
<h2>一、内容选题策略</h2>
<p>好的选题是成功的一半。在挠脚心vk平台上，以下类型的视频内容更容易获得用户关注：</p>
<p><strong>趣味挑战类</strong>：设计新颖有趣的挠脚心挑战，邀请朋友参与，增加互动性和趣味性。</p>
<p><strong>教程分享类</strong>：分享挠脚心相关的技巧、经验和心得，提供实用价值。</p>
<p><strong>搞笑合集类</strong>：收集整理平台上最有趣的挠脚心瞬间，制作成合集视频。</p>
<h2>二、拍摄与制作技巧</h2>
<p>视频质量直接影响用户的观看体验。以下是一些实用的拍摄建议：</p>
<p>使用自然光线或柔和的补光，确保画面明亮清晰；选择安静的环境进行录音，保证声音质量；保持画面稳定，避免过度抖动。</p>
<h2>三、发布与推广策略</h2>
<p>发布时选择合适的标题和封面，使用挠脚心vk相关的话题标签，在多个社交平台进行推广，可以有效提升视频的曝光量和播放量。</p>`,
    category: 'shipin',
    topics: ['naojiaoxin-vk-shipin', 'vk-naoyang-shipin', 'quwei-shipin'],
    coverImage: 'https://readdy.ai/api/search-image?query=Creative%20video%20production%20setup%20with%20warm%20lighting%2C%20professional%20camera%20equipment%20on%20wooden%20desk%2C%20soft%20coral%20and%20cream%20background%2C%20modern%20content%20creator%20workspace%2C%20editorial%20photography&width=800&height=450&seq=article-cover-03&orientation=landscape',
    date: '2025-08-03',
    readTime: '7分钟',
    viewCount: 18920,
  },
  {
    slug: 'naojiaoxin-ziyuan-heji-zhengli',
    title: '挠脚心vk资源合集整理：最全导航指南',
    excerpt: '精心整理的挠脚心vk资源导航，涵盖视频、社区、工具、教程等各类资源，一站式解决你的所有需求。',
    content: `<p>为了帮助挠脚心vk的爱好者们更高效地找到所需资源，我们整理了这份全面的资源导航指南。无论你是在寻找精彩视频、社区讨论还是有用的工具，这里都有你需要的。</p>
<h2>一、视频资源导航</h2>
<p>挠脚心vk视频资源主要集中在以下几个渠道：VK官方频道、热门创作者主页、话题标签下的视频聚合。通过关注这些渠道，你可以第一时间获取最新、最热的视频内容。</p>
<h2>二、社区资源导航</h2>
<p>挠脚心vk社区讨论主要集中在各类VK群组和讨论版块中。活跃的社区包括：挠脚心交流群、VK趣味社区、挠痒视频分享圈等。</p>
<h2>三、实用工具推荐</h2>
<p>以下工具可以帮助你更好地使用挠脚心vk平台：内容翻译工具、视频下载工具、数据分析工具等。合理使用这些工具，可以大幅提升你的使用体验。</p>`,
    category: 'ziyuan',
    topics: ['naojiaoxin-ziyuan', 'naojiaoxin-vk-shipin', 'naojiaoxin-shequ'],
    coverImage: 'https://readdy.ai/api/search-image?query=Organized%20digital%20resource%20library%20concept%2C%20minimalist%20workspace%20with%20tidy%20folders%20and%20navigation%20elements%2C%20warm%20coral%20and%20cream%20aesthetic%2C%20soft%20natural%20lighting%2C%20clean%20modern%20design&width=800&height=450&seq=article-cover-04&orientation=landscape',
    date: '2025-07-30',
    readTime: '6分钟',
    viewCount: 12560,
  },
  {
    slug: 'vk-naoyang-tiaozhan-redu',
    title: 'VK挠痒挑战热度飙升：为何成为现象级话题',
    excerpt: '深度分析VK挠痒挑战为何在短期内迅速走红，探讨其背后的社交传播机制和用户心理需求。',
    content: `<p>最近几个月，VK挠痒挑战话题在挠脚心vk平台上迅速走红，成为现象级的热门话题。本文将深入分析这一现象背后的原因。</p>
<h2>一、社交传播机制</h2>
<p>VK挠痒挑战之所以能够快速传播，很大程度上得益于其<strong>天然的社交属性</strong>。挑战类内容具有强烈的参与感和互动性，用户不仅是内容的消费者，也可以成为内容的创造者。</p>
<p>当一位用户发布挑战视频后，其好友和关注者很容易被带动参与，形成<strong>链式传播效应</strong>。这种传播方式在VK平台上尤为高效。</p>
<h2>二、用户心理需求</h2>
<p>从心理学角度来看，挠痒挑战满足了用户的多种需求：<strong>娱乐需求</strong>——观看有趣的内容带来愉悦感；<strong>社交需求</strong>——参与挑战拉近人与人之间的距离；<strong>自我表达需求</strong>——通过创意视频展现个性。</p>
<h2>三、平台助推因素</h2>
<p>VK平台的算法推荐机制也为挠痒挑战的走红提供了助力。平台会根据用户的兴趣偏好，精准推荐相关内容，形成<strong>正反馈循环</strong>。</p>`,
    category: 'huati',
    topics: ['vk-naoyang-shipin', 'jiaoxin-tiaozhan', 'vk-redian'],
    coverImage: 'https://readdy.ai/api/search-image?query=Social%20media%20trending%20concept%20with%20viral%20content%20visualization%2C%20warm%20gradient%20background%2C%20digital%20connection%20nodes%2C%20modern%20minimalist%20style%2C%20coral%20and%20cream%20tones%2C%20editorial%20photography&width=800&height=450&seq=article-cover-05&orientation=landscape',
    date: '2025-07-28',
    readTime: '9分钟',
    viewCount: 31200,
  },
  {
    slug: 'naojiaoxin-vk-xinshou-rumen',
    title: '挠脚心vk新手入门：从零开始的全方位指南',
    excerpt: '专为挠脚心vk新用户准备的入门教程，涵盖平台介绍、功能使用、内容发现和社区参与的完整指导。',
    content: `<p>欢迎来到挠脚心vk的世界！如果你刚刚接触到这个平台，可能会被琳琅满目的内容所吸引，同时也可能有些不知所措。别担心，这篇入门指南将帮助你快速上手。</p>
<h2>一、平台基础介绍</h2>
<p>挠脚心vk是一个以挠脚心相关内容为核心的内容聚合平台。在这里，你可以找到<strong>丰富多样的视频内容</strong>、参与<strong>活跃的社区讨论</strong>、浏览<strong>深度的文章资讯</strong>，以及发现<strong>各种有趣的话题标签</strong>。</p>
<h2>二、快速开始</h2>
<p>首先，建议你从首页的<strong>热门推荐</strong>开始浏览，这是了解平台内容风格最快的方式。当你找到感兴趣的内容时，可以点击进入详情页查看完整内容。</p>
<p>通过<strong>分类导航</strong>，你可以按照视频、社区、文章等不同类别来浏览内容，更精准地找到你想要的。</p>
<h2>三、参与社区互动</h2>
<p>不要只是浏览，积极参与互动会让你的体验更加丰富。你可以对喜欢的内容<strong>点赞</strong>、<strong>收藏</strong>，在评论区<strong>分享你的看法</strong>，或者通过<strong>话题标签</strong>发现更多相关内容。</p>`,
    category: 'wenzhang',
    topics: ['naojiaoxin-vk-shipin', 'naojiaoxin-jiaoliu', 'naojiaoxin-shequ'],
    coverImage: 'https://readdy.ai/api/search-image?query=Beginner%20friendly%20digital%20platform%20onboarding%20concept%2C%20warm%20welcoming%20interface%20design%2C%20soft%20coral%20and%20cream%20colors%2C%20modern%20minimalist%20aesthetic%2C%20gentle%20natural%20lighting%2C%20clean%20composition&width=800&height=450&seq=article-cover-06&orientation=landscape',
    date: '2025-07-25',
    readTime: '5分钟',
    viewCount: 28760,
  },
  {
    slug: 'naojiaoxin-vk-shequ-redian-taolun',
    title: '挠脚心vk社区热点讨论：用户最关心的十大问题',
    excerpt: '汇总挠脚心vk社区中最受关注的热点讨论话题，深入解答用户最关心的十大问题，涵盖内容发现、创作技巧等多个方面。',
    content: `<p>在挠脚心vk社区中，每天都有大量的讨论话题被发起。我们整理了近期用户最关心的十大热点问题，并给出详细解答。</p>
<h2>一、内容发现类问题</h2>
<p><strong>Q: 如何快速找到高质量的挠脚心vk视频？</strong></p>
<p>A: 可以通过以下方式：关注热门创作者、使用话题标签搜索、浏览分类页面的热门推荐、参考社区中的资源分享帖。</p>
<p><strong>Q: 有哪些值得关注的挠脚心vk创作者？</strong></p>
<p>A: 建议从社区推荐榜单和热门视频排行榜入手，逐步发现符合你口味的内容创作者。</p>
<h2>二、平台使用类问题</h2>
<p><strong>Q: 如何参与挠脚心vk的话题讨论？</strong></p>
<p>A: 进入社区讨论区，选择你感兴趣的话题，在帖子下方发表评论或创建新的讨论帖即可参与。</p>
<h2>三、内容创作类问题</h2>
<p><strong>Q: 新手如何开始创作挠脚心vk视频？</strong></p>
<p>A: 从简单的趣味挑战开始，使用手机即可拍摄，重点在于创意和真诚的表达。</p>`,
    category: 'shequ',
    topics: ['naojiaoxin-shequ', 'naojiaoxin-huati', 'naojiaoxin-jiaoliu'],
    coverImage: 'https://readdy.ai/api/search-image?query=Community%20discussion%20and%20Q&width=800&height=450&seq=article-cover-07&orientation=landscape',
    date: '2025-07-20',
    readTime: '11分钟',
    viewCount: 21980,
  },
  {
    slug: 'naojiaoxin-vk-weilai-qushi',
    title: '挠脚心vk未来趋势展望：2025下半年内容方向预测',
    excerpt: '基于平台数据和行业趋势，预测2025下半年挠脚心vk的内容发展方向，为创作者和用户提供参考。',
    content: `<p>随着挠脚心vk平台的持续发展，2025下半年将迎来哪些新的变化和趋势？本文基于现有数据和行业观察，做出以下预测。</p>
<h2>一、内容形式创新</h2>
<p>预计下半年，挠脚心vk视频内容将向<strong>更高质量和更多元化</strong>的方向发展。短剧形式、互动视频、直播内容等新形式将逐步兴起，为用户提供更丰富的观看体验。</p>
<h2>二、社区生态完善</h2>
<p>社区功能将持续升级，<strong>创作者激励计划</strong>、<strong>内容分级体系</strong>、<strong>用户成长系统</strong>等机制的引入，将使平台生态更加完善和健康。</p>
<h2>三、技术赋能内容</h2>
<p>AI技术的应用将为挠脚心vk平台带来新的可能：智能内容推荐、自动字幕生成、内容质量评估等技术将提升用户体验和创作效率。</p>`,
    category: 'wenzhang',
    topics: ['naojiaoxin-huati', 'vk-redian', 'naojiaoxin-vk-shipin'],
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20digital%20trend%20forecast%20concept%2C%20abstract%20data%20visualization%20with%20warm%20lighting%2C%20modern%20technology%20aesthetic%2C%20coral%20and%20cream%20gradient%2C%20clean%20minimalist%20composition%2C%20editorial%20photography&width=800&height=450&seq=article-cover-08&orientation=landscape',
    date: '2025-07-15',
    readTime: '7分钟',
    viewCount: 14530,
  },
];

export const videos = [
  { slug: 'quwei-naojiaoxin-tiaozhan', title: '趣味挠脚心挑战合集', duration: '15:32', views: 128500, thumbnail: 'https://readdy.ai/api/search-image?query=Fun%20playful%20challenge%20concept%20with%20warm%20lighting%2C%20friends%20laughing%20together%20in%20cozy%20setting%2C%20soft%20coral%20and%20cream%20tones%2C%20candid%20moment%2C%20editorial%20style%2C%20natural%20aesthetic&width=640&height=360&seq=video-thumb-01&orientation=landscape' },
  { slug: 'vk-naoyang-jingxuan', title: 'VK挠痒精选集锦', duration: '22:08', views: 98500, thumbnail: 'https://readdy.ai/api/search-image?query=Compilation%20video%20highlights%20concept%2C%20warm%20ambient%20lighting%2C%20playful%20atmosphere%2C%20soft%20coral%20and%20cream%20background%2C%20editorial%20photography%2C%20clean%20modern%20aesthetic&width=640&height=360&seq=video-thumb-02&orientation=landscape' },
  { slug: 'naojiaoxin-gaoxiao-shunjian', title: '挠脚心搞笑瞬间TOP20', duration: '10:45', views: 76500, thumbnail: 'https://readdy.ai/api/search-image?query=Humorous%20moment%20captured%20in%20warm%20lighting%2C%20genuine%20laughter%20and%20joy%2C%20soft%20coral%20and%20cream%20tones%2C%20candid%20photography%20style%2C%20natural%20composition&width=640&height=360&seq=video-thumb-03&orientation=landscape' },
  { slug: 'jiaoxin-hudong-jiaocheng', title: '脚心互动趣味教程', duration: '18:20', views: 56700, thumbnail: 'https://readdy.ai/api/search-image?query=Tutorial%20style%20video%20concept%20with%20warm%20lighting%2C%20step%20by%20step%20demonstration%2C%20soft%20coral%20and%20cream%20background%2C%20clean%20modern%20aesthetic%2C%20editorial%20photography&width=640&height=360&seq=video-thumb-04&orientation=landscape' },
  { slug: 'vk-quwei-shipin-daquan', title: 'VK趣味视频大全', duration: '25:40', views: 89300, thumbnail: 'https://readdy.ai/api/search-image?query=Entertainment%20video%20collection%20concept%2C%20warm%20playful%20atmosphere%2C%20soft%20coral%20and%20cream%20tones%2C%20modern%20minimalist%20style%2C%20editorial%20photography%2C%20clean%20composition&width=640&height=360&seq=video-thumb-05&orientation=landscape' },
  { slug: 'naojiaoxin-remen-heji', title: '挠脚心热门合集2025', duration: '30:15', views: 112000, thumbnail: 'https://readdy.ai/api/search-image?query=Popular%20video%20highlights%20montage%20concept%2C%20warm%20ambient%20lighting%2C%20trending%20content%20visualization%2C%20soft%20coral%20and%20cream%20palette%2C%20editorial%20style%2C%20modern%20aesthetic&width=640&height=360&seq=video-thumb-06&orientation=landscape' },
];

export const communityPosts = [
  { slug: 'fenxiang-wo-de-naojiaoxin-jingli', title: '分享一下我的挠脚心vk使用经历', author: '挠痒达人', replies: 128, likes: 356, date: '2025-08-09', category: 'shequ' },
  { slug: 'tuijian-ji-ge-haowan-de-shipin', title: '推荐几个超好玩的挠脚心视频', author: 'VK探索者', replies: 95, likes: 278, date: '2025-08-08', category: 'shipin' },
  { slug: 'naojiaoxin-tiaozhan-jiqiao', title: '挠脚心挑战有哪些技巧？求分享', author: '新手小白', replies: 203, likes: 412, date: '2025-08-07', category: 'huati' },
  { slug: 'vk-shequ-guize-jiedu', title: 'VK社区规则详细解读', author: '社区管理员', replies: 67, likes: 189, date: '2025-08-06', category: 'shequ' },
  { slug: 'zuixin-naoyang-shipin-tuijian', title: '最新挠痒视频资源推荐帖', author: '资源猎人', replies: 156, likes: 345, date: '2025-08-05', category: 'ziyuan' },
  { slug: 'naojiaoxin-vk-shiyong-jiqiao', title: '挠脚心vk使用小技巧分享', author: '技巧达人', replies: 89, likes: 234, date: '2025-08-04', category: 'wenzhang' },
];

export const faqItems = [
  {
    question: '挠脚心vk是什么？',
    answer: '挠脚心vk是一个专注于挠脚心相关内容的全方位内容聚合平台，汇聚了挠脚心vk相关的视频、社区讨论、文章资讯和话题标签，帮助用户一站式发现和浏览所有相关内容。',
  },
  {
    question: '如何在挠脚心vk上找到感兴趣的内容？',
    answer: '你可以通过以下方式发现内容：浏览首页的热门推荐、使用分类导航按类别筛选、点击话题标签查看相关内容、在搜索框中输入关键词搜索，或者参与社区讨论获取其他用户的推荐。',
  },
  {
    question: '挠脚心vk平台上的内容都是免费的吗？',
    answer: '是的，挠脚心vk平台上的所有内容均免费向用户开放。你可以自由浏览视频、阅读文章、参与社区讨论，无需支付任何费用。部分第三方链接可能涉及外部平台，请以该平台的规则为准。',
  },
  {
    question: '如何参与挠脚心vk的社区讨论？',
    answer: '进入社区讨论区后，你可以浏览已有的讨论帖并发表评论，也可以创建新的讨论话题。参与讨论时请遵守社区规则，保持友善和尊重的交流氛围。',
  },
  {
    question: '挠脚心vk平台的内容多久更新一次？',
    answer: '挠脚心vk平台的内容持续更新中。视频资源、社区帖子和文章资讯每天都有新内容发布。建议定期访问平台或关注热门话题标签，获取最新内容动态。',
  },
  {
    question: '在挠脚心vk上遇到问题怎么办？',
    answer: '如果你在使用过程中遇到任何问题，可以通过关于我们页面的联系方式与我们取得联系，或查看帮助中心的相关指南。我们的团队会尽快为你提供帮助。',
  },
];

export const aboutInfo = {
  brandName: '挠脚心vk',
  slogan: '探索挠脚心vk的全方位内容聚合平台',
  introduction: '挠脚心vk是当前热门的综合内容平台，致力于为用户提供挠脚心vk相关的视频、社区、内容资源与话题讨论的一站式服务。我们聚合了全网的优质内容资源，帮助用户快速找到关于挠脚心vk的一切信息，满足不同用户的内容需求。',
  mission: '我们的使命是打造中文互联网上最全面、最优质的挠脚心vk内容聚合平台，让每一位对挠脚心vk感兴趣的用户都能在这里找到他们想要的内容。',
  vision: '成为中文互联网挠脚心vk领域最具影响力的内容平台，推动优质内容的创作与传播。',
  reputation: [
    { name: '用户小王', rating: 5, comment: '终于找到了一个全面的挠脚心vk内容平台！视频、社区、文章应有尽有，每天都会来看看有什么新内容。' },
    { name: '创作者小李', rating: 5, comment: '作为一个挠脚心vk的内容创作者，这个平台给了我很多灵感和创作方向，社区氛围也非常好。' },
    { name: '资深用户老张', rating: 5, comment: '使用半年多了，内容更新很及时，分类也很清晰。推荐给所有对挠脚心vk感兴趣的朋友！' },
    { name: '新用户小陈', rating: 4, comment: '刚接触挠脚心vk不久，这个平台帮我快速了解了这个领域，入门指南写得特别详细实用。' },
  ],
  contact: {
    email: 'contact@naojiaoxinvk.com',
    wechat: 'naojiaoxinvk_official',
    qq: '1234567890',
    address: '中国北京市朝阳区科技园区',
  },
};

export const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/shipin', label: '视频资源' },
  { path: '/category/shequ', label: '社区讨论' },
  { path: '/category/wenzhang', label: '文章资讯' },
  { path: '/category/huati', label: '话题标签' },
  { path: '/category/ziyuan', label: '资源合集' },
  { path: '/about', label: '关于我们' },
];